module.exports = __webpack_public_path__ + "static/media/BANNERS_CONFIRMACION_PSE_BANNER_INTENTA_NUEVAMENTE.55689569.jpg";